// Single source of truth for the in-article navigation.
// The sidebar renders these in order and the scroll-spy watches the same ids,
// so adding a section here is all that is needed to wire it into both.
export const ARTICLE_SECTIONS = [
  {
    id: "why-dictate",
    label: "Why Dictate in Google Docs Instead of Typing",
  },
  {
    id: "how-it-works",
    label: "How Zero Typing AI Works in Google Docs",
  },
  {
    id: "voice-to-text-trust",
    label: "Voice to Text Google Docs Users Can Actually Trust",
  },
  {
    id: "speech-to-text-extension",
    label: "A Speech-to-Text Extension Built for Real Work",
  },
  {
    id: "vs-google",
    label: "Zero Typing AI vs. Google's Built-In Voice Typing",
  },
  {
    id: "who-uses-it",
    label: "Who Uses Voice Typing for Google Docs",
  },
  {
    id: "faqs",
    label: "Frequently Asked Questions",
  },
  {
    id: "start-dictating",
    label: "Start Dictating in Google Docs Today",
  },
];

// Offset used by both the scroll-spy and the smooth-scroll target so a section
// never lands underneath the fixed navbar.
export const SCROLL_OFFSET = 120;
